import * as React from 'react';
import {SpringTooling} from '../../__SharedTypes';
import {NumberInputValue} from '../NumberInputValue';
import {NUMBER_INPUT_VARIANTS} from '../_constants';
import {NumberInputTrailingControls} from './NumberInputTrailingControls';
import {ScrubZone} from '../ScrubZone/ScrubZone';
import {ScrubDirection, StepDirection} from '../_types';

export const NumberInputDefault = ({
  isScrubbing,
  isDisabled,
  isError,
  isFocused,
  isMax,
  isMin,
  shouldShowTrailingControls,
  onScrubChange,
  onSetIsScrubbing,
  onStepClick,
  ...props
}: {
  isScrubbing?: boolean;
  isDisabled?: boolean;
  isError?: boolean;
  isFocused?: boolean;
  isMax?: boolean;
  isMin?: boolean;
  shouldShowTrailingControls?: boolean;
  onScrubChange: (direction: ScrubDirection, isSkip: boolean) => void;
  onSetIsScrubbing: (isScrubbing: boolean) => void;
  onStepClick: (direction: StepDirection, isSkip: boolean) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> &
  SpringTooling) => {
  const handleScrubChange = React.useCallback(
    (direction: ScrubDirection, isSkip: boolean) => {
      onScrubChange(direction, isSkip);
    },
    [onScrubChange]
  );

  const handleStepClick = React.useCallback(
    (direction: StepDirection, isSkip: boolean) => {
      onStepClick(direction, isSkip);
    },
    [onStepClick]
  );

  const handleSetIsScrubbing = React.useCallback(
    (isScrubbingState: boolean) => {
      onSetIsScrubbing(isScrubbingState);
    },
    [onSetIsScrubbing]
  );

  return (
    <div role="group">
      <ScrubZone
        isScrubbing={isScrubbing}
        onScrub={handleScrubChange}
        setIsScrubbing={handleSetIsScrubbing}
      >
        <NumberInputValue variant={NUMBER_INPUT_VARIANTS.DEFAULT} {...props}>
          <NumberInputTrailingControls
            isDisabled={isDisabled}
            isError={isError}
            isFocused={isFocused}
            isMax={isMax}
            isMin={isMin}
            onStepClick={handleStepClick}
            shouldShowTrailingControls={shouldShowTrailingControls}
          />
        </NumberInputValue>
      </ScrubZone>
    </div>
  );
};
